import SystemMeter from '@components/_shared/SystemMeter';
import UnitList from '@components/_shared/UnitListContainer/UnitList';
import { Outlet } from 'react-router';

function UnitListPageLayout() {
  return (
    <div className='home-row'>
      <div className='fcol'>
        <SystemMeter />
        <UnitList />
      </div>
      <div className='fcol'>
        <Outlet />
      </div>
    </div>
  );
}

export default UnitListPageLayout;
